<template>
    <div class="text-center mt-2">
        <h3 class="title">{{ $t('institution.email.title') }}</h3>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    font-size: clamp(24px, 3.2vw, 40px);
    color: $text;
    font-weight: 500;
    font-family: $font-heading;
}
</style>